<template>
    <div class="refund-details">
      <div class="audit-content-details">
            <div class="audit-content-details-title medium">
              Refund Details
            </div>
            <div class="audit-content-details-text">
              <div>
                <div class="ash medium">Brand</div>
                <div>{{orderInfo.brandName}}</div>
              </div>
              <div>
                <div class="ash medium">Order ID </div>
                <div>{{orderInfo.uid}}</div>
              </div>
              <div>
                <div class="ash medium">Order Placed </div>
                <div>{{orderInfo.payTime}}</div>
              </div>
            </div>
            <div class="audit-content-details-id">
              <div class="audit-details-id-title">
                <div>
                    <span class="ash medium">Service Order ID</span>
                    <span>{{serviceOrder.sid}}</span>
                  </div>
                  <div>
                      <span class="ash medium">Create Date</span>
                      <span>{{serviceOrder.createAt}}</span>
                  </div>
                  <div class="medium">
                      <span class="ash">Refund Total</span>
                      <span>${{(serviceOrder.refundTotalAmount).toFixed(2)}}</span>
                  </div>
              </div>
              <div class="audit-details-indent">
                <!-- 参与收缩 -->
                <div>
                  <span class="ash">Item Total</span>
                  <span>${{serviceOrder.goodsAmount}}</span>
                </div>
                <div v-if="serviceOrder.brandDiscout>0 ||  serviceOrder.shopvidiDiscout>0">
                  <span class="ash">Item Dis.</span>
                  <span>${{(serviceOrder.brandDiscout+serviceOrder.shopvidiDiscout).toFixed(2)}}</span>
                </div>
                <div>
                  <span class="ash">Shipping Fee</span>
                  <span>${{serviceOrder.goodsShipping}}</span>
                </div>
                <div v-if="serviceOrder.goodsShippingDisc>0">
                  <span class="ash">Shipping Dis.</span>
                  <span>${{serviceOrder.goodsShippingDisc}}</span>
                </div>
                <div>
                  <span class="ash">Quantity Returning</span>
                  <span>{{serviceOrder.goodsNum}}</span>
                </div>
                <div>
                  <span class="ash">Reason for Return</span>
                  <span>{{serviceOrder.reasonReturn}}</span>
                </div>
                <div>
                  <span class="ash">Service Order Type</span>
                  <span>{{getType(serviceOrder.type)}}</span>
                </div>
                <div>
                  <span class="ash">Product Status</span>
                  <span>{{getProductStatus(serviceOrder.productStatus)}}</span>
                </div>
              </div>
            </div>

      </div>
    </div>
</template>

<script>
export default {
  props: {
    orderInfo: {
      type: Object,
      default: function() {}
    },
    serviceOrder: {
      type: Object,
      default: function() {}
    }
  },
  methods: {
    getType(typeCode) {
      if (typeCode === 1) {
        return 'Refund'
      }
    },
    getProductStatus(productStatus) {
      if (productStatus === 1) {
        return 'Received'
      } else if (productStatus === 2) {
        return 'Not Received'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.refund-details{
  padding: 20px;
}
.audit-content-details{
      padding: 10px 0 22px 0;
      border-bottom: 1px solid #E1E1E1 ;
      .audit-content-details-text{
        padding: 16px 0;
        border-bottom: 1px solid #E1E1E1;
        div{
          display: flex;
           justify-content: space-between;
           line-height: 32px;
        }
      }
      .audit-content-details-id{
        padding-top: 16px;
        .audit-details-id-title{
          div{
            display: flex;
            justify-content: space-between;
            line-height: 32px;
          }
        }
        .audit-details-indent{
          div{
            display: flex;
            justify-content: space-between;
            line-height: 28px;
          }
        }
      }
    }
.medium{
  font-family: Satoshi-medium;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/refund-details.vue